import React from "react";
import PropTypes from "prop-types";
import { InlineList } from "./List";
import { Link } from "./Link";
import { useTheme } from "./theme";

const borderWidthPx = 2;

function Tag({ label, link }) {
    const {
        baseFontSizePx,
        baseLineHeight,
        tagBackgroundColor,
        tagTextColor,
        contrastTextColor,
        modularScale,
    } = useTheme();

    const fontSize = modularScale(-1);
    const lineHeight =
        (baseLineHeight * baseFontSizePx - 2 * borderWidthPx) /
        baseFontSizePx /
        fontSize;

    return (
        <span className="tag">
            <Link className="tag-link" to={link}>
                {label}
            </Link>
            <style jsx>{`
                .tag :global(.tag-link:link),
                .tag :global(.tag-link:visited),
                .tag :global(.tag-link:hover),
                .tag :global(.tag-link:active) {
                    text-decoration: none;
                }
                .tag :global(.tag-link) {
                    display: block;
                    white-space: nowrap;
                    border: ${borderWidthPx}px solid ${tagBackgroundColor};
                    padding: 0 1em;
                    background-color: ${tagBackgroundColor};
                    color: ${tagTextColor};
                    border-radius: 20px;
                    font-size: ${fontSize}em;
                    line-height: ${lineHeight};
                    text-transform: lowercase;
                }
                .tag :global(.tag-link:focus),
                .tag :global(.tag-link:active) {
                    outline: 0;
                    border-color: ${contrastTextColor};
                }
            `}</style>
        </span>
    );
}

Tag.propTypes = {
    label: PropTypes.string.isRequired,
    link: Link.propTypes.to,
};

export function Tags(props) {
    const { className = "", tags } = props;
    const renderedTags = tags.map(({ label, link }, i) => ({
        key: i,
        display: <Tag label={label} link={link} />,
    }));
    return (
        <InlineList
            className={className}
            items={renderedTags}
            solitaryItemClassName="single-tag"
            listClassName="tags-list"
            itemClassName="tags-list__item"
        />
    );
}

Tags.propTypes = {
    className: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape(Tag.propTypes)).isRequired,
};

Tags.defaultProps = {
    className: "",
};
